package com.cybersoftsolution.cybersoftsolutionweb.components.layouts

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.sections.PageSection
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.css.TextShadow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textShadow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.Text


@Composable
inline fun ContentLayout(
    pageSection: PageSection,
    title:String? = null,
    sectionModifier: Modifier = Modifier,
    contentModifier: Modifier = Modifier,
    crossinline content: @Composable () -> Unit
){

    Column  (
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
        modifier = Modifier
            .id(
                pageSection.name
//                    .orEmpty()
//                    .replace("id","",true)
//                    .replace("section","",true)
            )
            .fillMaxWidth()
            .then(sectionModifier)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
    ) {
        Column  (
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
            modifier = Modifier
                .fillMaxWidth(100.vh)
                .id(pageSection.id+"content")
                .then(contentModifier)

        ) {
            title?.let {
                H3 (
                    attrs = Modifier
                        .margin(bottom = 24.px)
                        .textShadow(
                            offsetX = 0.px,
                            offsetY = 0.px,
                            blurRadius = 15.px,
                            color = Theme.HalfBlack.rgb
                        )
                        .color(Theme.Secondary.rgb)
                        .fontFamily("sans-serif")
                        .toAttrs()
                ) {
                    Text(it)
                }
            }


            content()




        }


    }


}